export default {
  title: '忘記密碼',
  form: {
    email: {
      placeholder: '請輸入 email',
      feedback: {
        required: '請輸入 email',
        format: '請輸入有效的 email'
      }
    },
    submit: '發送'
  },
  sent: '已發送重設密碼信至{email}',
  emailNotExists: '此Email不存在',
  sendFailed: '發送失敗'
};
